export function formatToken(value: string): string {
  return value
    .replaceAll('_', ' ')
    .replaceAll('-', ' ')
    .replace(/^./, (character) => character.toUpperCase())
}
